/**
 * Directory of published policies. Individual routes stay on LegalDocument.
 */
import React from 'react';
import { useTheme } from '../ThemeContext';
import Footer from './Footer';
import { FOOTER_LINKS, followPolicyLink } from '../utils/legal';

const LegalIndex = ({ onBack }) => {
  const { colors } = useTheme();

  return (
    <div className="app-scroll" style={{ ...styles.container, background: colors.background, color: colors.text }}>
      <div style={styles.content}>
        {onBack && (
          <button
            type="button"
            onClick={onBack}
            style={{ ...styles.backButton, color: '#59c4c4', borderColor: '#59c4c4' }}
          >
            ← Back
          </button>
        )}
        <h1 style={{ ...styles.title, color: colors.text }}>Legal</h1>
        <p style={{ ...styles.intro, color: colors.textSecondary }}>
          Policies for using Pacarion.
        </p>
        <nav aria-label="Policies" style={{ ...styles.list, background: colors.surface, borderColor: colors.border }}>
          {FOOTER_LINKS.map((page, index) => (
            <a
              key={page.path}
              href={page.path}
              onClick={followPolicyLink}
              style={{
                ...styles.row,
                color: colors.text,
                borderBottom: index < FOOTER_LINKS.length - 1 ? `1px solid ${colors.border}` : 'none',
              }}
            >
              <span>{page.title}</span>
              <span aria-hidden="true" style={{ color: colors.textSecondary }}>›</span>
            </a>
          ))}
        </nav>
      </div>
      <Footer />
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    width: '100%',
    maxWidth: '100%',
    overflowX: 'hidden',
    paddingTop: 'calc(2rem + env(safe-area-inset-top, 0px))',
    paddingBottom: 'calc(2rem + env(safe-area-inset-bottom, 0px))',
    paddingLeft: 'max(1rem, env(safe-area-inset-left, 0px))',
    paddingRight: 'max(1rem, env(safe-area-inset-right, 0px))',
  },
  content: {
    maxWidth: '640px',
    margin: '0 auto',
    width: '100%',
    minWidth: 0,
    flex: '1 0 auto',
  },
  backButton: {
    background: 'transparent',
    border: '2px solid',
    padding: '0.5rem 1rem',
    borderRadius: '0.5rem',
    cursor: 'pointer',
    fontWeight: 'bold',
    marginBottom: '1.5rem',
  },
  title: {
    fontSize: '2rem',
    fontWeight: 600,
    margin: '0 0 0.5rem',
  },
  intro: {
    margin: '0 0 1.25rem',
    lineHeight: 1.5,
  },
  list: {
    border: '1px solid',
    borderRadius: '0.75rem',
    overflow: 'hidden',
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '1rem',
    minHeight: '56px',
    padding: '0.9rem 1.1rem',
    textDecoration: 'none',
    fontSize: '1rem',
    fontWeight: 500,
    boxSizing: 'border-box',
  },
};

export default LegalIndex;
